import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { QuizStoreSelectorClick } from "../../utils/Analytics.js"
import { getProductMarkerNormalAsync, getProductMarkerHoverAsync, getVideoMarkerNormalAsync, giftingVideoId } from '../../utils/StaticAssetManager.js';
import Marker from './Marker.jsx';
import ComposableModal from '../ui/modals/composable/ComposableModal.jsx';
import HotspotCircle from './ReactSVGHotspots/HotspotCircle';
import HotspotPlus from './ReactSVGHotspots/HotspotPlus';
import { getHotspotIconStyle } from '../../utils/StoreConfigManager.js';
import { getIconSVGAsync } from '../ui/ui-layer-panel/SVGIcons.jsx';
import TextModal from '../ui/modals/text/TextModal';
import ImageCarouselModal from '../ui/modals/image-carousel/ImageCarouselModal';
import { ModalTypes } from '../ui/modals/utils/ModalConstants';
import IFrameModal from '../ui/modals/iFrame/IFrameModal.jsx';
import QuizModal from '../ui/modals/quiz/QuizModal.jsx';
import { ImageHotspotClicked, QuizMarkerClicked, ImageCarouselHotspotClicked, TextPopUpHotSpotClicked } from '../../utils/Analytics.js';
import HotspotHorse from './ReactSVGHotspots/HotspotHorse.jsx';
import { isMobileDevice } from '../../utils/DeviceDetector';
import HotspotNew from './ReactSVGHotspots/HotspotNew.jsx';

export const ModalMarkerTypes = Object.freeze({
    Image: "image",
    Video: "video",
    Text: "text_with_button"
});

export const MarkerImageAssets = Object.freeze({
    VideoMarker: "https://cdn.obsess-vr.com/ferragamo/video.svg",
    ImageMarker: "https://cdn.obsess-vr.com/ferragamo/Explore_new.svg",
    InfoMarker: "https://cdn.obsess-vr.com/infoFinal.svg",
    QuizMarker: "https://cdn.obsess-vr.com/ferragamo/QuizIcon.svg",
});

class ModalMarker extends Component {
    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
        this.onModalHidden = this.onModalHidden.bind(this);

        this.state = {
            isShowingModal: false,
            videoMuted: false,
            normalSpriteUrl: '',
            hoverSpriteUrl: '',
            svgSprite: null,
            svgSpriteString: ''
        };
        this.mounted = false;
    }

    setSVGIcon(markerIconUrl) {
        getIconSVGAsync(null, markerIconUrl)
            .then(svgString => this.setState({ svgSpriteString: svgString }))
            .catch(error => console.error(error));
    }

    componentDidMount() {
        switch (this.props.type) {
            case ModalMarkerTypes.Video:
                this.setState({ normalSpriteUrl: MarkerImageAssets.VideoMarker, hoverSpriteUrl: MarkerImageAssets.VideoMarker })
                //Gifting room video
                console.log("modal");
                if (this.props.hotspotId === giftingVideoId && this.props.modalContent.hotspot_type === "video") {
                    this.setState({ isShowingModal: true, videoMuted: isMobileDevice() });
                }
                break;
            case ModalMarkerTypes.Image:
                this.setState({ normalSpriteUrl: MarkerImageAssets.ImageMarker, hoverSpriteUrl: MarkerImageAssets.ImageMarker })
                break;
            case ModalTypes.QuizModal:
                this.setState({ normalSpriteUrl: MarkerImageAssets.QuizMarker, hoverSpriteUrl: MarkerImageAssets.QuizMarker })
                break;
            case ModalMarkerTypes.Text:
                if (this.props.modalContent.url === undefined) {
                    this.setState({ normalSpriteUrl: MarkerImageAssets.InfoMarker, hoverSpriteUrl: MarkerImageAssets.InfoMarker })
                } else {
                    this.setState({ svgSprite: HotspotHorse })
                }
                break;
            default:
                this.setState({ svgSprite: HotspotHorse })
                break;
        }

        if (this.props.type === ModalMarkerTypes.Text && this.props.modalContent.url === undefined) {
            this.setState({ normalSpriteUrl: MarkerImageAssets.InfoMarker, hoverSpriteUrl: MarkerImageAssets.InfoMarker })
        }
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    onClick() {
        if (this.props.type === 'text_with_button' && !!this.props.modalContent.title) {
            const text = this.props.modalContent.title;
            ImageHotspotClicked(text);
        } else if (this.props.type === 'text_with_button') {
            const sceneName = this.props.currentSceneName;
            TextPopUpHotSpotClicked(sceneName);
        } else if (this.props.type === 'quiz') {
            const text = this.props.currentSceneName;
            QuizMarkerClicked(text);
        } else if (this.props.type === 'image_carousel') {
            const sceneName = this.props.currentSceneName;
            ImageCarouselHotspotClicked(sceneName);
        }

        if (!this.mounted) {
            return;
        }
        this.setState({ isShowingModal: true });
    }

    onModalHidden() {
        if (!this.mounted) {
            return;
        }
        this.setState({ isShowingModal: false });
    }

    getTextModal() {
        return (
            <TextModal
                modalContent={this.props.modalContent}
                onModalHidden={this.onModalHidden}
                primaryColor={this.props.primaryColor}
                secondaryColor={this.props.secondaryColor}
                hotspotId={this.props.hotspotId}
                roomId={this.props.roomId}
            />
        );
    }

    getImageCarouselModal() {
        return (
            <ImageCarouselModal
                modalContent={this.props.modalContent}
                onModalHidden={this.onModalHidden}
                primaryColor={this.props.primaryColor}
                secondaryColor={this.props.secondaryColor}
                hotspotId={this.props.hotspotId}
            />
        );
    }

    getQuizModal() {
        QuizStoreSelectorClick();
        return (
            <QuizModal
                modalContent={this.props.modalContent}
                onModalHidden={this.onModalHidden}
                primaryColor={this.props.primaryColor}
                secondaryColor={this.props.secondaryColor}
            />
        );
    }

    getComposableModal() {
        return (
            <ComposableModal
                type={this.props.type}
                modalContent={this.props.modalContent}
                onModalHidden={this.onModalHidden}
                hotspotId={this.props.hotspotId}
                roomId={this.props.roomId}
                videoMuted={this.state.videoMuted}
            />
        );
    }

    getIFrameModal() {
        return (
            <IFrameModal
                modalContent={this.props.modalContent}
                onModalHidden={this.onModalHidden}
                primaryColor={this.props.primaryColor}
                secondaryColor={this.props.secondaryColor}
            />
        );
    }

    renderModal() {
        if (this.state.isShowingModal && this.props.type) {
            switch (this.props.type) {
                case ModalTypes.TextModal:
                    return this.getTextModal();
                case ModalTypes.ImageCarousel:
                    return this.getImageCarouselModal();
                case ModalTypes.QuizModal:
                    return this.getQuizModal();
                case ModalTypes.IFrameModal:
                    return this.getIFrameModal();
                default:
                    return this.getComposableModal();
            }
        }
        return null;
    }

    render() {
        const { normalSpriteUrl, hoverSpriteUrl, svgSprite, svgSpriteString } = this.state;
        return (
            <div>
                {this.renderModal()}
                <Marker
                    transform={this.props.transform}
                    colliderTransform={this.props.colliderTransform}
                    normalSpriteUrl={this.props.hotspotId === '6196eafc069ba3d99800346a' ? '' : normalSpriteUrl}
                    hoverSpriteUrl={this.props.hotspotId === '6196eafc069ba3d99800346a' ? '' : hoverSpriteUrl}
                    svgSprite={this.props.hotspotId === '6196eafc069ba3d99800346a' ? HotspotNew : svgSprite}
                    svgSpriteString={this.props.hotspotId === '6196eafc069ba3d99800346a' ? '' : svgSpriteString}
                    showVisual={this.props.showVisual}
                    onClick={this.onClick}
                    primaryColor={this.props.primaryColor}
                    secondaryColor={this.props.secondaryColor}
                />
            </div>
        );
    }
}

ModalMarker.propTypes = {
    transform: PropTypes.array.isRequired,
    colliderTransform: PropTypes.array.isRequired,
    type: PropTypes.string.isRequired,
    modalContent: PropTypes.object.isRequired,
    showVisual: PropTypes.bool,
    primaryColor: PropTypes.string,
    secondaryColor: PropTypes.string,
    hotspotId: PropTypes.string,
    roomId: PropTypes.string
};

export default ModalMarker;
